import React, { useCallback, useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDHeadlineText,
  FDPaper,
  FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { ErrorList2 } from 'Components/ComponentLibrary/Molecules/ErrorList2';


const Layout = () => {
  const {
    resource, onSubmit, errors,
  } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const [saving, setSaving] = useState(false);
  const submit = useCallback(async () => {
    try {
      setSaving(true);
      await onSubmit({ rejectOnError: true });
      await refreshPageContentCollection();
      clearModalCollection();
      setSaving(false);
    } catch (err) {
      setSaving(false);
      // Do not log an error, the error is shown in this layout already
    }
  }, [onSubmit, clearModalCollection, refreshPageContentCollection]);

  return (
    <FDPaper padding={4} flex={1}>
      <FDStack direction={'column'} spacing={2} justifyContent={'space-between'} height={'100%'}>
        <FDStack direction={'column'} spacing={4}>
          <FDHeadlineText value={resource.attr('title')} />
          <MetaControlField attr="monthlySurplus" surplusTooHighText={resource.attr('surplusTooHighText')} />
          <ErrorList2 title="Validation errors" errors={errors} />
        </FDStack>
        <FDStack direction={'row'} spacing={2} justifyContent={'flex-end'}>
          <FDSecondaryActionButton label="Cancel" onClick={clearModalCollection} size={'sm'} />
          <FDPrimaryActionButton
            loading={saving}
            onClick={submit}
            label="Save"
            size={'sm'}
          />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

export default Layout;
